import React, { useEffect, useState, useRef } from "react"
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardImg,
  CardTitle,
  Button,
} from "reactstrap"
import Slider from "react-slick"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ArticleCardCarousel from "../../additional_components/ArticleCard"
import FilterPanel from "../../components/KeywordTrackingNewUIPage/FilterPanel"
import { useFilters } from "../../hooks/useFilters"
import { api, token } from "../../utils/variables"
import axios from "axios"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"
import "../../../src/assets/scss/app.scss"
import "./WeeklyInsightsDashboard.css"
import MaintenanceBadge from "../../components/Common/MaintenanceBadge"
import InsightsPageHeader from "../../components/MetaInsight/InsightsPageHeader"
import FlagSelectDropdown from "../../components/Common/FlagSelectDropdown"
import { useAnalytics, ANALYTICS_EVENTS } from "../../analytics"

import { Link, useNavigate } from "react-router-dom"
import { getSessionItem, setSessionItem, setLocalItem } from "../../utils/storage"
import flags from "../../common/flag"
import SEO from "../../components/Common/SEO"
import { PAGE_SEO, STRUCTURED_DATA } from "../../config/seoConfig"
import { generateCanonicalUrl, generateSlug, applySEODate } from "../../utils/seoUtils"
import TrackedGame from "../../additional_components/TrackedGame"
import PlatformsApi from "../../services/platformsApi"


const carouselSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false,
  swipe: true,
  touchMove: true,
  centerMode: false,
  centerPadding: "0px",
  responsive: [
    { breakpoint: 8000, settings: { slidesToShow: 12, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 6000, settings: { slidesToShow: 10, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 4000, settings: { slidesToShow: 8, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 2400, settings: { slidesToShow: 6, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 1920, settings: { slidesToShow: 5, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 1400, settings: { slidesToShow: 4, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 992, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false, dots: true, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 576, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false, dots: true, centerMode: false, centerPadding: "0px" } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false, dots: true, centerMode: false, centerPadding: "0px" } },
  ],
}

const WeeklyInsightsDashboard = () => {
  const { filterSections } = useFilters()
  const navigate = useNavigate()
  const { trackEvent } = useAnalytics()

  // Keep the site title consistent with the home page
  document.title = "Keyquest | VR SEO Intelligence Tools Powered by AI & Big Data"

  const [trendingApps, setTrendingApps] = useState([])
  const [trendingCountry, setTrendingCountry] = useState(() => {
    try {
      return sessionStorage.getItem('trending_selectedCountry') || 'US'
    } catch (e) {
      return 'US'
    }
  })
  const [trendingLanguage, setTrendingLanguage] = useState(() => {
    try {
      return sessionStorage.getItem('trending_selectedLanguage')
    } catch (e) {
      return null
    }
  })
  const [trendingPage, setTrendingPage] = useState(1)
  
  const [trendingTotal, setTrendingTotal] = useState(0)
  const [trendingLastUpdated, setTrendingLastUpdated] = useState(null)

  const [newReleases, setNewReleases] = useState([])
  const [newReleasesCountry, setNewReleasesCountry] = useState(() => {
    try {
      return sessionStorage.getItem('newReleases_selectedCountry') || 'US'
    } catch (e) {
      return 'US'
    }
  })
  const [newReleasesLanguage, setNewReleasesLanguage] = useState(() => {
    try {
      return sessionStorage.getItem('newReleases_selectedLanguage')
    } catch (e) {
      return null
    }
  })
  const [newReleasesPage, setNewReleasesPage] = useState(1)
  // replaced later with responsive value after `isMobile` is defined
  let newReleasesPerPage = 5
  const [newReleasesTotal, setNewReleasesTotal] = useState(0)
  const [newReleasesLastUpdated, setNewReleasesLastUpdated] = useState(null)
  const [topSelling, setTopSelling] = useState([])
  const [topEarning, setTopEarning] = useState([])
  const [topEarningCountry, setTopEarningCountry] = useState(() => {
    try {
      return sessionStorage.getItem('topEarning_selectedCountry') || 'US'
    } catch (e) {
      return 'US'
    }
  })
  const [topEarningLanguage, setTopEarningLanguage] = useState(() => {
    try {
      return sessionStorage.getItem('topEarning_selectedLanguage')
    } catch (e) {
      return null
    }
  })
  const [topEarningPage, setTopEarningPage] = useState(1)
  // replaced later with responsive value after `isMobile` is defined
  let topEarningPerPage = 5
  const [topEarningTotal, setTopEarningTotal] = useState(0)
  const [topEarningLastUpdated, setTopEarningLastUpdated] = useState(null)
  const [mostPopular, setMostPopular] = useState([])
  const [topDiscount, setTopDiscount] = useState([])
  const [topDiscountLoading, setTopDiscountLoading] = useState(false)
  const [topDiscountCountry, setTopDiscountCountry] = useState(() => {
    try {
      return sessionStorage.getItem('topDiscount_selectedCountry') || 'US'
    } catch (e) {
      return 'US'
    }
  })
  const [topDiscountLanguage, setTopDiscountLanguage] = useState(() => {
    try {
      return sessionStorage.getItem('topDiscount_selectedLanguage')
    } catch (e) {
      return null
    }
  })
  const [topDiscountLastUpdated, setTopDiscountLastUpdated] = useState(null)
  const [topDiscountPage, setTopDiscountPage] = useState(1)
  const [topDiscountTotal, setTopDiscountTotal] = useState(0)
  const [preOrders, setPreOrders] = useState([])
  // keep full arrays so we can paginate client-side without re-fetching
  const [mostPopularAll, setMostPopularAll] = useState([])
  const [mostPopularAllCountry, setMostPopularAllCountry] = useState(null)
  const [mostPopularAllLanguage, setMostPopularAllLanguage] = useState(null)
  const [trendingAll, setTrendingAll] = useState([])
  const [trendingAllCountry, setTrendingAllCountry] = useState(null)
  const [trendingAllLanguage, setTrendingAllLanguage] = useState(null)
  const [newReleasesAll, setNewReleasesAll] = useState([])
  const [newReleasesAllCountry, setNewReleasesAllCountry] = useState(null)
  const [newReleasesAllLanguage, setNewReleasesAllLanguage] = useState(null)
  const [topEarningAll, setTopEarningAll] = useState([])
  const [topEarningAllCountry, setTopEarningAllCountry] = useState(null)
  const [topEarningAllLanguage, setTopEarningAllLanguage] = useState(null)
  const [platforms, setPlatforms] = useState([])
  // Always defaults to Meta on initial load of this page, regardless of what was
  // last picked on another Weekly Insights page — platform choice is local to
  // each page, not shared across them.
  const [selectedPlatform, setSelectedPlatform] = useState('meta')
  const [platformsLoading, setPlatformsLoading] = useState(true)
  const [trendingAllPlatform, setTrendingAllPlatform] = useState(null)
  const [newReleasesAllPlatform, setNewReleasesAllPlatform] = useState(null)
  const [mostPopularAllPlatform, setMostPopularAllPlatform] = useState(null)
  const [topEarningAllPlatform, setTopEarningAllPlatform] = useState(null)
  const [loading, setLoading] = useState(true)
  const [mostPopularLoading, setMostPopularLoading] = useState(false)
  const [trendingLoading, setTrendingLoading] = useState(false)
  const [newReleasesLoading, setNewReleasesLoading] = useState(false)
  const [topEarningLoading, setTopEarningLoading] = useState(false)
  const [filterPanelOpen, setFilterPanelOpen] = useState(false)
  const [appliedFilters, setAppliedFilters] = useState(() => {
    try {
      const raw = sessionStorage.getItem('weekly_appliedFilters')
      return raw ? JSON.parse(raw) : {}
    } catch (e) {
      return {}
    }
  })
  const [trendingFilterPanelOpen, setTrendingFilterPanelOpen] = useState(false)
  const [trendingAppliedFilters, setTrendingAppliedFilters] = useState(() => {
    try {
      const raw = sessionStorage.getItem('weekly_trendingAppliedFilters')
      return raw ? JSON.parse(raw) : {}
    } catch (e) {
      return {}
    }
  })
  const [newReleasesFilterPanelOpen, setNewReleasesFilterPanelOpen] = useState(false)
  const [newReleasesAppliedFilters, setNewReleasesAppliedFilters] = useState(() => {
    try {
      const raw = sessionStorage.getItem('weekly_newReleasesAppliedFilters')
      return raw ? JSON.parse(raw) : {}
    } catch (e) {
      return {}
    }
  })
  const [topEarningFilterPanelOpen, setTopEarningFilterPanelOpen] = useState(false)
  const [topEarningAppliedFilters, setTopEarningAppliedFilters] = useState(() => {
    try {
      const raw = sessionStorage.getItem('weekly_topEarningAppliedFilters')
      return raw ? JSON.parse(raw) : {}
    } catch (e) {
      return {}
    }
  })
  const [topDiscountFilterPanelOpen, setTopDiscountFilterPanelOpen] = useState(false)
  const [topDiscountAppliedFilters, setTopDiscountAppliedFilters] = useState(() => {
    try {
      const raw = sessionStorage.getItem('weekly_topDiscountAppliedFilters')
      return raw ? JSON.parse(raw) : {}
    } catch (e) {
      return {}
    }
  })
  const [selectedCountry, setSelectedCountry] = useState(() => {
    try {
      return sessionStorage.getItem('mostPopular_selectedCountry') || 'US'
    } catch (e) {
      return 'US'
    }
  })
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    try {
      return sessionStorage.getItem('mostPopular_selectedLanguage')
    } catch (e) {
      return null
    }
  })
  const [countriesList, setCountriesList] = useState([])
  const [countryOptions, setCountryOptions] = useState([])
  const [countriesLoading, setCountriesLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage] = useState(10)
  const [totalItems, setTotalItems] = useState(0)
  const [mostPopularLastUpdated, setMostPopularLastUpdated] = useState(null)

  // track window width to decide mobile vs desktop layouts (used for Most Popular)
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200,
  )
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])
  const isMobile = windowWidth < 768
  const trendingPerPage = isMobile ? 5 : 10
  // responsive per-page for other sections
  newReleasesPerPage = isMobile ? 5 : 10
  topEarningPerPage = isMobile ? 5 : 10

  // countryOptions will be loaded from backend `/countries/` and stored in state

  // We'll derive language options from the selected country's `locales` returned by `/countries/`.
  // To keep small, provide a helper to prettify locale strings for labels and a helper
  // to get locales for a given country code.
  const prettifyLocaleLabel = (locale) => {
    const map = {
      english: 'English',
      espanol: 'Español',
      francais: 'Français',
      deutsch: 'Deutsch',
      italiano: 'Italiano',
      nihongo: '日本語',
      hangugeo: '한국어',
      zhongwen: '中文',
      nederlands: 'Nederlands',
      polski: 'Polski',
      portugues: 'Português',
      dansk: 'Dansk',
      suomi: 'Suomi',
      norsk_bokmal: 'Norsk',
      svenska: 'Svenska'
    }
    return map[locale] || locale.replace(/_/g, ' ').replace(/(^|\s)\S/g, s => s.toUpperCase())
  }

  const getLocalesForCountry = (countryCode) => {
    if (!countriesList || countriesList.length === 0) return []
    const c = countriesList.find(x => x.code === countryCode)
    if (!c || !Array.isArray(c.locales)) return []
    return c.locales.map(l => ({ value: l, label: prettifyLocaleLabel(l) }))
  }

  const getCountryForLocale = (locale) => {
    if (!countriesList || countriesList.length === 0) return null
    const c = countriesList.find(x => Array.isArray(x.locales) && x.locales.includes(locale))
    return c ? c.code : null
  }

  // Language options are now provided dynamically from the backend `/countries/`

  // Every country/language picker on this page now renders through
  // FlagSelectDropdown (which defaults to this exact look — see its own file),
  // so the react-select `CountryOption`/`SingleValue`/`selectControlStyles`
  // trio that used to back them was removed along with the last `<Select>`.

  // Shared styles for View All and Filters controls so all sections match
  const sharedControlBase = {
    border: '1px solid rgba(53, 55, 72, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 400,
    gap: '6px',
    cursor: 'pointer',
    padding: '6px 10px',
    background: '#171821'
  }

  const viewAllStyle = { ...sharedControlBase, minWidth: '100px', textDecoration: 'none' }
  const filterBtnStyle = { ...sharedControlBase, minWidth: '90px' }

  useEffect(() => {
    // First fetch available countries/locales, then fetch section data
    const loadCountries = async () => {
      setCountriesLoading(true)
      setPlatformsLoading(true)
      let list = []
      try {
        const [countriesRes, fetchedPlatforms] = await Promise.all([
          axios.get(`${api}/countries/`),
          PlatformsApi.fetchPlatforms()
        ])
        list = countriesRes.data?.data || []
        setCountriesList(list)
        setCountryOptions(list.map(c => ({ value: c.code, label: c.name })))
        setPlatforms(fetchedPlatforms || PlatformsApi.getDefaultPlatforms())

        // initialize per-section languages where null
        const ensureLang = (countryCode, setter) => {
          const c = list.find(x => x.code === countryCode)
          if (c && Array.isArray(c.locales) && c.locales.length > 0) setter(prev => prev || c.locales[0])
        }
        ensureLang(selectedCountry, setSelectedLanguage)
        ensureLang(trendingCountry, setTrendingLanguage)
        ensureLang(newReleasesCountry, setNewReleasesLanguage)
        ensureLang(topEarningCountry, setTopEarningLanguage)
        ensureLang(topDiscountCountry, setTopDiscountLanguage)
      } catch (err) {
        console.error('Error loading countries:', err)
        setPlatforms(PlatformsApi.getDefaultPlatforms())
      } finally {
        setCountriesLoading(false)
        setPlatformsLoading(false)

        // Compute initial/default languages synchronously from the returned `list` so
        // we can pass them to the first round of section fetches. Relying on
        // setState (setSelectedLanguage etc.) is async and causes the first
        // requests to sometimes omit `language`.
        const getFirstLocaleFor = (countryCode) => {
          const c = list.find(x => x.code === countryCode)
          return c && Array.isArray(c.locales) && c.locales.length ? c.locales[0] : null
        }

        const initialSelectedLanguage = getFirstLocaleFor(selectedCountry)
        const initialTrendingLanguage = getFirstLocaleFor(trendingCountry)
        const initialNewReleasesLanguage = getFirstLocaleFor(newReleasesCountry)
        const initialTopEarningLanguage = getFirstLocaleFor(topEarningCountry)
        const initialTopDiscountLanguage = getFirstLocaleFor(topDiscountCountry)

        // then load rest of data with explicit defaults so `language` is included
        // on the first requests instead of waiting for state updates
        await fetchAllData(
          initialSelectedLanguage,
          initialTrendingLanguage,
          initialNewReleasesLanguage,
          initialTopEarningLanguage,
          initialTopDiscountLanguage
        )
      }
    }

    loadCountries()
  }, [])

  // Handle filter apply
  const handleFilterApply = (filters) => {
    setAppliedFilters(filters)
    try { sessionStorage.setItem('weekly_appliedFilters', JSON.stringify(filters || {})) } catch (e) { }
    setCurrentPage(1) // Reset to page 1 when filters change
    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_APPLIED, {
      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
      filters: JSON.stringify(filters || {}),
    })
    fetchMostPopular(filters, selectedCountry, selectedLanguage, 1)
  }

  const handleTrendingFilterApply = (filters) => {
    setTrendingAppliedFilters(filters)
    try { sessionStorage.setItem('weekly_trendingAppliedFilters', JSON.stringify(filters || {})) } catch (e) { }
    setTrendingPage(1)
    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_APPLIED, {
      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
      filters: JSON.stringify(filters || {}),
    })
    fetchTrendingApps(trendingCountry, trendingLanguage, 1, filters)
  }

  const handleNewReleasesFilterApply = (filters) => {
    setNewReleasesAppliedFilters(filters)
    try { sessionStorage.setItem('weekly_newReleasesAppliedFilters', JSON.stringify(filters || {})) } catch (e) { }
    setNewReleasesPage(1)
    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_APPLIED, {
      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
      filters: JSON.stringify(filters || {}),
    })
    fetchNewReleases(newReleasesCountry, newReleasesLanguage, 1, filters)
  }

  const handleTopEarningFilterApply = (filters) => {
    setTopEarningAppliedFilters(filters)
    try { sessionStorage.setItem('weekly_topEarningAppliedFilters', JSON.stringify(filters || {})) } catch (e) { }
    setTopEarningPage(1)
    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_APPLIED, {
      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
      filters: JSON.stringify(filters || {}),
    })
    fetchTopEarning(topEarningCountry, topEarningLanguage, 1, filters)
  }

  const handleTopDiscountFilterApply = (filters) => {
    // Top Discount has its own filters and should not alter Most Popular
    setTopDiscountAppliedFilters(filters)
    try { sessionStorage.setItem('weekly_topDiscountAppliedFilters', JSON.stringify(filters || {})) } catch (e) { }
    setTopDiscountFilterPanelOpen(false)
    setTopDiscountLastUpdated(new Date())
    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_APPLIED, {
      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
      filters: JSON.stringify(filters || {}),
    })
    // Trigger Top Discount fetch with applied filters
    fetchTopDiscount(topDiscountCountry, topDiscountLanguage, 1, filters)
  }

  // Handlers to remove individual applied filters for each section.
  const handleRemoveMostPopularFilter = (key) => {
    const newFilters = { ...(appliedFilters || {}) }
    if (Object.prototype.hasOwnProperty.call(newFilters, key)) {
      delete newFilters[key]
      setAppliedFilters(newFilters)
      try { sessionStorage.setItem('weekly_appliedFilters', JSON.stringify(newFilters || {})) } catch (e) { }
      setCurrentPage(1)
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_REMOVED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
        filter_key: key,
      })
      fetchMostPopular(newFilters, selectedCountry, selectedLanguage, 1)
    }
  }

  const handleRemoveTrendingFilter = (key) => {
    const newFilters = { ...(trendingAppliedFilters || {}) }
    if (Object.prototype.hasOwnProperty.call(newFilters, key)) {
      delete newFilters[key]
      setTrendingAppliedFilters(newFilters)
      try { sessionStorage.setItem('weekly_trendingAppliedFilters', JSON.stringify(newFilters || {})) } catch (e) { }
      setTrendingPage(1)
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_REMOVED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
        filter_key: key,
      })
      fetchTrendingApps(trendingCountry, trendingLanguage, 1, newFilters)
    }
  }

  const handleRemoveNewReleasesFilter = (key) => {
    const newFilters = { ...(newReleasesAppliedFilters || {}) }
    if (Object.prototype.hasOwnProperty.call(newFilters, key)) {
      delete newFilters[key]
      setNewReleasesAppliedFilters(newFilters)
      try { sessionStorage.setItem('weekly_newReleasesAppliedFilters', JSON.stringify(newFilters || {})) } catch (e) { }
      setNewReleasesPage(1)
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_REMOVED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
        filter_key: key,
      })
      fetchNewReleases(newReleasesCountry, newReleasesLanguage, 1, newFilters)
    }
  }

  const handleRemoveTopEarningFilter = (key) => {
    const newFilters = { ...(topEarningAppliedFilters || {}) }
    if (Object.prototype.hasOwnProperty.call(newFilters, key)) {
      delete newFilters[key]
      setTopEarningAppliedFilters(newFilters)
      try { sessionStorage.setItem('weekly_topEarningAppliedFilters', JSON.stringify(newFilters || {})) } catch (e) { }
      setTopEarningPage(1)
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_REMOVED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
        filter_key: key,
      })
      fetchTopEarning(topEarningCountry, topEarningLanguage, 1, newFilters)
    }
  }

  const handleRemoveTopDiscountFilter = (key) => {
    const newFilters = { ...(topDiscountAppliedFilters || {}) }
    if (Object.prototype.hasOwnProperty.call(newFilters, key)) {
      delete newFilters[key]
      setTopDiscountAppliedFilters(newFilters)
      try { sessionStorage.setItem('weekly_topDiscountAppliedFilters', JSON.stringify(newFilters || {})) } catch (e) { }
      setTopDiscountLastUpdated(new Date())
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_FILTER_REMOVED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
        filter_key: key,
      })
      // re-fetch top discount with updated filters
      fetchTopDiscount(topDiscountCountry, topDiscountLanguage, 1, newFilters)
    }
  }

  const handlePlatformChange = (platformId) => {
    setSelectedPlatform(platformId)
    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PLATFORM_CHANGED, {
      platform: platformId,
    })
    fetchAllData(selectedLanguage, trendingLanguage, newReleasesLanguage, topEarningLanguage, topDiscountLanguage, platformId)
  }

  const fetchAllData = async (
    selLang = selectedLanguage,
    trLang = trendingLanguage,
    nrLang = newReleasesLanguage,
    teLang = topEarningLanguage,
    tdLang = topDiscountLanguage,
    platform = selectedPlatform
  ) => {
    try {
      // Fetch all data in parallel, passing explicit language defaults so
      // the initial requests include the `language` query param instead of
      // relying on asynchronous state updates.
      await Promise.all([
          fetchTrendingApps(trendingCountry, trLang, 1, trendingAppliedFilters, platform),
          fetchNewReleases(newReleasesCountry, nrLang, 1, newReleasesAppliedFilters, platform),
          fetchTopSelling(selectedCountry, selLang, platform),
          fetchTopEarning(topEarningCountry, teLang, 1, topEarningAppliedFilters, platform),
          fetchMostPopular(appliedFilters, selectedCountry, selLang, 1, platform),
          fetchPreOrders(selectedCountry, selLang, platform),
          fetchTopDiscount(topDiscountCountry, tdLang, 1, topDiscountAppliedFilters, platform)
      ])
    } catch (error) {
      console.error("Error fetching weekly insights data:", error)
    } finally {
      // mark overall loading complete and set Top Discount last-updated timestamp
      setTopDiscountLastUpdated(new Date())
      setLoading(false)
    }
  }

  const fetchTrendingApps = async (country = trendingCountry, language = trendingLanguage, page = trendingPage, filters = trendingAppliedFilters, platform = selectedPlatform) => {
    try {
      console.info('fetchTrendingApps called', { country, language, page, filters, platform })
      // If we already have full data and filters haven't changed, paginate locally instead of re-fetching
      if (
        trendingAll && trendingAll.length > 0 &&
        JSON.stringify(filters) === JSON.stringify(trendingAppliedFilters) &&
        country === trendingAllCountry &&
        language === trendingAllLanguage &&
        platform === trendingAllPlatform
      ) {
        const start = (page - 1) * trendingPerPage
        setTrendingApps(trendingAll.slice(start, start + trendingPerPage))
        setTrendingPage(page)
        return
      }
      setTrendingLoading(true)
      const params = {}
      // include country & language in params for this section
      if (country) params.country = country
      if (language) params.language = language
      // Add filter params
      if (filters.price) params.price = Array.isArray(filters.price) ? filters.price.join(',') : filters.price
      if (filters.rating) params.rating = Array.isArray(filters.rating) ? filters.rating.join(',') : filters.rating
      if (filters.genre) params.genre = Array.isArray(filters.genre) ? filters.genre.join(',') : filters.genre
      if (filters.platform) params.platform = Array.isArray(filters.platform) ? filters.platform.join(',') : filters.platform
      if (filters.sort_by) params.sort_by = filters.sort_by
      if (filters.bundle) params.bundle = Array.isArray(filters.bundle) ? filters.bundle.join(',') : filters.bundle
      if (filters.number_of_players) params.number_of_players = filters.number_of_players

      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`

      const resMeta = await axios.get(`${api}/tracker/stats/${platform}/trending`, { params, headers })
      const combinedTrendingApps = [...(resMeta.data?.games || [])]

      setTrendingTotal(combinedTrendingApps.length)

      // Client-side pagination
      const startIndex = (page - 1) * trendingPerPage
      const endIndex = startIndex + trendingPerPage
      const paginatedApps = combinedTrendingApps.slice(startIndex, endIndex)

      sessionStorage.setItem("trendingApps", JSON.stringify(combinedTrendingApps))
      setTrendingAll(combinedTrendingApps)
      setTrendingAllCountry(country)
      setTrendingAllLanguage(language)
      setTrendingAllPlatform(platform)
      setTrendingApps(paginatedApps)
      setTrendingLastUpdated(new Date())
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
        platform,
        country,
      })
    } catch (error) {
      console.error("Error fetching trending apps:", error)
    }
    finally {
      setTrendingLoading(false)
    }
  }

  const fetchNewReleases = async (country = newReleasesCountry, language = newReleasesLanguage, page = newReleasesPage, filters = newReleasesAppliedFilters, platform = selectedPlatform) => {
    try {
      console.info('fetchNewReleases called', { country, language, page, filters, platform })
      // If we already have full data and filters haven't changed, paginate locally instead of re-fetching
      if (
        newReleasesAll && newReleasesAll.length > 0 &&
        JSON.stringify(filters) === JSON.stringify(newReleasesAppliedFilters) &&
        country === newReleasesAllCountry &&
        language === newReleasesAllLanguage &&
        platform === newReleasesAllPlatform
      ) {
        const start = (page - 1) * newReleasesPerPage
        setNewReleases(newReleasesAll.slice(start, start + newReleasesPerPage))
        setNewReleasesPage(page)
        return
      }
      setNewReleasesLoading(true)
      const params = {}
      if (country) params.country = country
      if (language) params.language = language
      // Add filter params
      if (filters.price) params.price = Array.isArray(filters.price) ? filters.price.join(',') : filters.price
      if (filters.rating) params.rating = Array.isArray(filters.rating) ? filters.rating.join(',') : filters.rating
      if (filters.genre) params.genre = Array.isArray(filters.genre) ? filters.genre.join(',') : filters.genre
      if (filters.platform) params.platform = Array.isArray(filters.platform) ? filters.platform.join(',') : filters.platform
      if (filters.sort_by) params.sort_by = filters.sort_by
      if (filters.bundle) params.bundle = Array.isArray(filters.bundle) ? filters.bundle.join(',') : filters.bundle
      if (filters.number_of_players) params.number_of_players = filters.number_of_players

      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`

      const metaResult = await axios.get(`${api}/tracker/stats/${platform}/releases`, { params, headers })
      const combinedNewReleases = [...(metaResult.data?.games || [])]

      setNewReleasesTotal(combinedNewReleases.length)

      // Client-side pagination
      const startIndex = (page - 1) * newReleasesPerPage
      const endIndex = startIndex + newReleasesPerPage
      const paginatedReleases = combinedNewReleases.slice(startIndex, endIndex)

      sessionStorage.setItem("newReleases", JSON.stringify(combinedNewReleases))
      setNewReleasesAll(combinedNewReleases)
      setNewReleasesAllCountry(country)
      setNewReleasesAllLanguage(language)
      setNewReleasesAllPlatform(platform)
      setNewReleases(paginatedReleases)
      setNewReleasesLastUpdated(new Date())
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
        platform,
        country,
      })
    } catch (error) {
      console.error("Error fetching new releases:", error)
    }
    finally {
      setNewReleasesLoading(false)
    }
  }

  const fetchTopSelling = async (country = selectedCountry, language = selectedLanguage, platform = selectedPlatform) => {
    try {
      const params = {}
      if (country) params.country = country
      if (language) params.language = language
      console.info('fetchTopSelling called', { params, platform })
      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`
      const res = await axios.get(`${api}/tracker/stats/${platform}/top_selling_this_week`, { params, headers })
      setTopSelling(res.data.games || [])
      sessionStorage.setItem("topSellingMeta", JSON.stringify(res.data.games))
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_SELLING,
        platform,
        country,
      })
    } catch (error) {
      console.error("Error fetching top selling:", error)
    }
  }

  const fetchTopEarning = async (country = topEarningCountry, language = topEarningLanguage, page = topEarningPage, filters = topEarningAppliedFilters, platform = selectedPlatform) => {
    try {
      console.info('fetchTopEarning called', { country, language, page, filters, platform })
      // If we already have full data and filters haven't changed, paginate locally instead of re-fetching
      if (
        topEarningAll && topEarningAll.length > 0 &&
        JSON.stringify(filters) === JSON.stringify(topEarningAppliedFilters) &&
        country === topEarningAllCountry &&
        language === topEarningAllLanguage &&
        platform === topEarningAllPlatform
      ) {
        const start = (page - 1) * topEarningPerPage
        setTopEarning(topEarningAll.slice(start, start + topEarningPerPage))
        setTopEarningPage(page)
        return
      }
      setTopEarningLoading(true)
      const params = {}
      if (country) params.country = country
      if (language) params.language = language
      // Add filter params
      if (filters.price) params.price = Array.isArray(filters.price) ? filters.price.join(',') : filters.price
      if (filters.rating) params.rating = Array.isArray(filters.rating) ? filters.rating.join(',') : filters.rating
      if (filters.genre) params.genre = Array.isArray(filters.genre) ? filters.genre.join(',') : filters.genre
      if (filters.platform) params.platform = Array.isArray(filters.platform) ? filters.platform.join(',') : filters.platform
      if (filters.sort_by) params.sort_by = filters.sort_by
      if (filters.bundle) params.bundle = Array.isArray(filters.bundle) ? filters.bundle.join(',') : filters.bundle
      if (filters.number_of_players) params.number_of_players = filters.number_of_players

      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`
      const res = await axios.get(`${api}/tracker/stats/${platform}/top_earning`, { params, headers })
      const allGames = res.data.games || []

      setTopEarningTotal(allGames.length)

      // Client-side pagination
      const startIndex = (page - 1) * topEarningPerPage
      const endIndex = startIndex + topEarningPerPage
      const paginatedGames = allGames.slice(startIndex, endIndex)

      setTopEarning(paginatedGames)
      setTopEarningAll(allGames)
      setTopEarningAllCountry(country)
      setTopEarningAllLanguage(language)
      setTopEarningAllPlatform(platform)
      sessionStorage.setItem("topEarningMeta", JSON.stringify(allGames))
      setTopEarningLastUpdated(new Date())
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
        platform,
        country,
      })
    } catch (error) {
      console.error("Error fetching top earning:", error)
    }
    finally {
      setTopEarningLoading(false)
    }
  }

  const fetchMostPopular = async (filters = {}, country = selectedCountry, language = selectedLanguage, page = currentPage, platform = selectedPlatform) => {
    try {
      console.info('fetchMostPopular called', { country, language, page, filters, platform })
      // If we already have full data and filters haven't changed, paginate locally instead of re-fetching
      if (
        mostPopularAll && mostPopularAll.length > 0 &&
        JSON.stringify(filters) === JSON.stringify(appliedFilters) &&
        country === mostPopularAllCountry &&
        language === mostPopularAllLanguage &&
        platform === mostPopularAllPlatform
      ) {
        const start = (page - 1) * itemsPerPage
        setMostPopular(mostPopularAll.slice(start, start + itemsPerPage))
        setCurrentPage(page)
        return
      }
      setMostPopularLoading(true)
      const params = {}
      if (country) params.country = country
      if (language) params.language = language
      // Add all filter params
      if (filters.price) params.price = Array.isArray(filters.price) ? filters.price.join(',') : filters.price
      if (filters.rating) params.rating = Array.isArray(filters.rating) ? filters.rating.join(',') : filters.rating
      if (filters.genre) params.genre = Array.isArray(filters.genre) ? filters.genre.join(',') : filters.genre
      if (filters.platform) params.platform = Array.isArray(filters.platform) ? filters.platform.join(',') : filters.platform
      if (filters.sort_by) params.sort_by = filters.sort_by
      if (filters.bundle) params.bundle = Array.isArray(filters.bundle) ? filters.bundle.join(',') : filters.bundle
      if (filters.number_of_players) params.number_of_players = filters.number_of_players
      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`
      const res = await axios.get(`${api}/tracker/stats/${platform}/most_popular`, { params, headers })
      const allGames = res.data.games || []
      setTotalItems(allGames.length)

      // Client-side pagination
      const startIndex = (page - 1) * itemsPerPage
      const endIndex = startIndex + itemsPerPage
      const paginatedGames = allGames.slice(startIndex, endIndex)

      setMostPopular(paginatedGames)
      setMostPopularAll(allGames)
      setMostPopularAllCountry(country)
      setMostPopularAllLanguage(language)
      setMostPopularAllPlatform(platform)
      sessionStorage.setItem("popularMeta", JSON.stringify(allGames))
      setMostPopularLastUpdated(new Date())
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
        platform,
        country,
      })
    } catch (error) {
      console.error("Error fetching most popular:", error)
    }
    finally {
      setMostPopularLoading(false)
    }
  }

  const fetchPreOrders = async (country = selectedCountry, language = selectedLanguage, platform = selectedPlatform, page = 1, filters = {}) => {
    try {
      console.info('fetchPreOrders called', { country, language, page, filters, platform })
      const params = {}
      if (country) params.country = country
      if (language) params.language = language

      if (filters.price) params.price = Array.isArray(filters.price) ? filters.price.join(',') : filters.price
      if (filters.rating) params.rating = Array.isArray(filters.rating) ? filters.rating.join(',') : filters.rating
      if (filters.genre) params.genre = Array.isArray(filters.genre) ? filters.genre.join(',') : filters.genre
      if (filters.platform) params.platform = Array.isArray(filters.platform) ? filters.platform.join(',') : filters.platform
      if (filters.sort_by) params.sort_by = filters.sort_by
      if (filters.bundle) params.bundle = Array.isArray(filters.bundle) ? filters.bundle.join(',') : filters.bundle
      if (filters.number_of_players) params.number_of_players = filters.number_of_players

      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`
      const res = await axios.get(`${api}/tracker/stats/${platform}/coming_soon_pre_orders`, { params, headers })
      const games = res.data.games || []
      setPreOrders(games)
      sessionStorage.setItem("preOrderMeta", JSON.stringify(games))
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.PRE_ORDERS,
        platform,
        country,
      })
    } catch (error) {
      console.error("Error fetching pre orders:", error)
    }
  }

  // Fetch Top Discount from API: /tracker/stats/{platform}/top_discount
  const fetchTopDiscount = async (country = topDiscountCountry, language = topDiscountLanguage, page = 1, filters = topDiscountAppliedFilters, platform = selectedPlatform) => {
    setTopDiscountLoading(true)
    try {
      console.info('fetchTopDiscount called', { country, language, page, filters, platform })
      const params = {}
      if (country) params.country = country
      if (language) params.language = language

      // add filters to params if provided
      if (filters && typeof filters === 'object') {
        if (filters.price) params.price = Array.isArray(filters.price) ? filters.price.join(',') : filters.price
        if (filters.rating) params.rating = Array.isArray(filters.rating) ? filters.rating.join(',') : filters.rating
        if (filters.genre) params.genre = Array.isArray(filters.genre) ? filters.genre.join(',') : filters.genre
        if (filters.platform) params.platform = Array.isArray(filters.platform) ? filters.platform.join(',') : filters.platform
        if (filters.sort_by) params.sort_by = filters.sort_by
        if (filters.bundle) params.bundle = Array.isArray(filters.bundle) ? filters.bundle.join(',') : filters.bundle
        if (filters.number_of_players) params.number_of_players = filters.number_of_players
      }

      const token = localStorage.getItem("authToken")
      const headers = {}
      if (token) headers.Authorization = `Bearer ${token}`

      const res = await axios.get(`${api}/tracker/stats/${platform}/top_discount`, { params, headers })
      const games = res.data.games || []
      setTopDiscount(games)
      setTopDiscountTotal(games.length)
      sessionStorage.setItem("topDiscountMeta", JSON.stringify(games))
      setTopDiscountLastUpdated(new Date())
      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEWED, {
        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
        platform,
        country,
      })
    } catch (error) {
      console.error('Error fetching top discount:', error)
    } finally {
      setTopDiscountLoading(false)
    }
  }

  const CarouselComponent = ({ game = [], title, slidesToShowOverride, insightType }) => {
    // responsive behaviour for card sizes and slides per view
    const [windowWidth, setWindowWidth] = useState(
      typeof window !== 'undefined' ? window.innerWidth : 1200,
    )

    // react-slick's own post-drag click suppression doesn't reliably stop the
    // wrapping <Link> from navigating once a mouse-drag has moved past a slide
    // boundary — the browser still fires a `click` on whatever slide is under
    // the cursor at mouseup. So we track drag distance ourselves: mousedown on
    // a slide records the start point, a window-level mousemove flips
    // `dragRef.moved` once the pointer has travelled past a small threshold,
    // and every slide's Link checks that same ref on click before navigating.
    const dragRef = useRef({ down: false, startX: 0, startY: 0, moved: false })

    useEffect(() => {
      const getPoint = (e) => (e.touches ? e.touches[0] : e)
      const onMove = (e) => {
        if (!dragRef.current.down) return
        const { clientX, clientY } = getPoint(e)
        if (Math.abs(clientX - dragRef.current.startX) > 6 || Math.abs(clientY - dragRef.current.startY) > 6) {
          dragRef.current.moved = true
        }
      }
      const onUp = () => {
        dragRef.current.down = false
        // Reset after the current task so the click event (which fires
        // synchronously right after mouseup) still sees `moved` as true.
        if (dragRef.current.moved) setTimeout(() => { dragRef.current.moved = false }, 0)
      }
      window.addEventListener('mousemove', onMove)
      window.addEventListener('mouseup', onUp)
      window.addEventListener('touchmove', onMove)
      window.addEventListener('touchend', onUp)
      return () => {
        window.removeEventListener('mousemove', onMove)
        window.removeEventListener('mouseup', onUp)
        window.removeEventListener('touchmove', onMove)
        window.removeEventListener('touchend', onUp)
      }
    }, [])

    const handleSlidePointerDown = (e) => {
      const point = e.touches ? e.touches[0] : e
      dragRef.current = { down: true, startX: point.clientX, startY: point.clientY, moved: false }
    }

    useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth)
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    const isMobileLocal = windowWidth < 768

    const getCardDimensions = () => {
      if (isMobileLocal) {
        return {
          maxWidth: '240px',
          minWidth: '210px',
          aspectRatio: '4 / 3',
          padding: '10px',
        }
      }
      // Tablet / Desktop: the image fills the card's width (via aspectRatio)
      // instead of a small fixed-pixel square floating in a much wider slide,
      // which is what left the big empty gaps on either side.
      return {
        maxWidth: '100%',
        minWidth: '100%',
        aspectRatio: '16 / 10',
        padding: '10px',
      }
    }

    const cardDims = getCardDimensions()

    // compute slidesToShow based on override and available items
    const baseSlidesToShow = slidesToShowOverride || carouselSettings.slidesToShow || 6
    const desiredSlidesToShow = isMobileLocal ? 1 : baseSlidesToShow
    const slidesToShow = Math.max(1, Math.min(desiredSlidesToShow, game.length || 1))

    // update responsive settings to respect override on larger breakpoints
    const updatedResponsive = carouselSettings.responsive?.map(resp => {
      if (resp.breakpoint >= 768 && slidesToShowOverride) {
        return {
          ...resp,
          settings: {
            ...resp.settings,
            slidesToShow: slidesToShowOverride,
          },
        }
      }
      return resp
    })

    // If an explicit override is provided, enforce it on all devices so the
    // carousel shows the requested number of slides (e.g., 10) regardless of width.
    const enforcedSlidesToShow = slidesToShowOverride ? slidesToShowOverride : slidesToShow

    const localSettings = {
      ...carouselSettings,
      slidesToShow: enforcedSlidesToShow,
      // If an explicit override is provided for non-mobile, disable responsive
      // breakpoint adjustments so the override (e.g. 10) is always honored.
      responsive: (slidesToShowOverride && !isMobileLocal) ? [] : updatedResponsive,
      infinite: (game.length || 0) > enforcedSlidesToShow,
    }

    // fixed gap/padding between cards (in px) to keep spacing consistent across devices
    const cardGap = 12
    const cardGapHalf = cardGap / 2

    if (!game || game.length === 0) {
      return (
        <div className="d-flex gap-3">
          {Array.from({ length: 5 }).map((_, idx) => (
            <div key={idx} style={{ minWidth: cardDims.minWidth }}>
              <Skeleton
                height={isMobileLocal ? 180 : 130}
                borderRadius={8}
                baseColor="#171821"
                highlightColor="#2a2b37"
                enableAnimation={true}
              />
              <Skeleton
                width="70%"
                height={16}
                style={{ marginTop: '12px' }}
                baseColor="#171821"
                highlightColor="#2a2b37"
                enableAnimation={true}
              />
            </div>
          ))}
        </div>
      )
    }

    return (
      <Slider {...localSettings} dots={false}>
        {game.map((app, index) => {
          const isMobile = isMobileLocal
          const cardPlatformIcon = app?.platformId ? PlatformsApi.getPlatformIcon(app.platformId, platforms) : dashboardPlatformIconUrl
          const cardMarkup = (
            <div
              style={{
                width: '100%',
                maxWidth: cardDims.maxWidth,
                minWidth: cardDims.minWidth,
                background: '#171821',
                border: '1px solid #353748',
                borderRadius: '14px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                margin: 'auto',
                cursor: 'pointer',
                padding: cardDims.padding,
                transition: 'border-color 0.2s ease',
                WebkitUserDrag: 'none',
                userSelect: 'none',
              }}
            >
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  aspectRatio: cardDims.aspectRatio,
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    borderRadius: isMobile ? '10px' : '10px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                  }}
                >
                  <CardImg
                    src={app.image_url || 'https://via.placeholder.com/253x250/171821/ffffff?text=Loading...'}
                    alt={app.name || 'Game Image'}
                    draggable={false}
                    onDragStart={(e) => e.preventDefault()}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center',
                      pointerEvents: 'none',
                    }}
                  />
                </div>

                {/* Platform icon only (no label) — the stacked list rows above
                    this carousel show icon + name, but there's no room for a
                    text label at this card size, so icon-only here. */}
                {cardPlatformIcon && (
                  <span
                    style={{
                      position: 'absolute',
                      right: isMobile ? -8 : -10,
                      bottom: isMobile ? -8 : -10,
                      width: isMobile ? 32 : 28,
                      height: isMobile ? 32 : 28,
                      borderRadius: '50%',
                      background: '#171821',
                      border: '2px solid #171821',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.4)',
                      pointerEvents: 'none',
                    }}
                  >
                    <img
                      src={cardPlatformIcon}
                      alt=""
                      aria-hidden="true"
                      draggable={false}
                      style={{ width: '72%', height: '72%', objectFit: 'contain', borderRadius: '2px' }}
                      onError={(e) => { e.target.parentElement.style.display = 'none' }}
                    />
                  </span>
                )}
              </div>

              <CardBody
                style={{
                  backgroundColor: 'transparent',
                  padding: '8px 2px 0',
                  width: '100%',
                }}
              >
                {/* Single line, ellipsis-truncated — the native `title` attribute
                    shows the full name as a tooltip on hover instead of wrapping
                    the card to 2-3 lines. */}
                <CardTitle
                  tag="h6"
                  className="mb-0 trending_game_titleup"
                  title={app.name}
                  style={{
                    fontSize: isMobile ? '14px' : '13px',
                    fontWeight: 600,
                    lineHeight: '1.35',
                    textAlign: 'center',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    margin: 0,
                    width: '100%',
                  }}
                >
                  {app.name}
                </CardTitle>
              </CardBody>
            </div>
          )

          return (
            <div
              key={app.item_id || `${index}`}
              style={{ padding: isMobile ? '0 12px' : `0 ${cardGapHalf}px`, boxSizing: 'border-box' }}
              onMouseDown={handleSlidePointerDown}
              onTouchStart={handleSlidePointerDown}
            >
              <Link
                to={`/xr/app/${generateSlug(app.name || '')}?id=${app.item_id}`}
                className="card-link-wrapper"
                draggable={false}
                onDragStart={(e) => e.preventDefault()}
                state={{ app_id: app.item_id, data: app, source_surface: `weekly_insight_${title || 'carousel'}` }}
                onClick={(e) => {
                  if (dragRef.current.moved) {
                    e.preventDefault()
                    return
                  }
                  trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_APP_SELECTED, {
                    app_id: app.item_id,
                    app_name: app.name,
                    insight_type: insightType || title,
                  })
                }}
              >
                {cardMarkup}
              </Link>
            </div>
          )
        })}
      </Slider>
    )
  }

  // Pagination helper: returns an array of page numbers to display (sliding window)
  const getVisiblePages = (totalPages, currentPage, maxButtons = 5) => {
    if (totalPages <= maxButtons) return Array.from({ length: totalPages }, (_, i) => i + 1)

    const half = Math.floor(maxButtons / 2)
    let start = currentPage - half
    let end = currentPage + half

    if (start < 1) {
      start = 1
      end = maxButtons
    }

    if (end > totalPages) {
      end = totalPages
      start = totalPages - maxButtons + 1
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
  }



  // For Most Popular section we want exactly 4 items per page on all devices
  const mostPopularPageSize = 4
  const mostPopularStartIndex = (currentPage - 1) * mostPopularPageSize
  let displayedMostPopular = []
  if (mostPopularAll && mostPopularAll.length > 0) {
    displayedMostPopular = mostPopularAll.slice(mostPopularStartIndex, mostPopularStartIndex + mostPopularPageSize)
  } else if (mostPopular && mostPopular.length > 0) {
    // if we only have the current page from server, try to derive a slice
    displayedMostPopular = mostPopular.slice(0, mostPopularPageSize)
  }

  // Reusable skeleton for stacked list sections (Top Discount, Most Popular)
  // Use a desktop-friendly height that matches `TrackedGame` card height
  const SECTION_SKELETON_HEIGHT_DESKTOP = 76
  const SectionListSkeleton = ({ count = 4, height = SECTION_SKELETON_HEIGHT_DESKTOP }) => (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton
          key={i}
          height={height}
          className="mb-3"
          borderRadius={10}
          baseColor="#171821"
          highlightColor="#2a2b37"
          enableAnimation={true}
        />
      ))}
    </>
  )

  // Used by the Most Popular mobile card markup below, which renders its own
  // bespoke layout instead of <TrackedGame> and so needs the platform badge
  // resolved here rather than through that component's `usePlatforms` lookup.
  const dashboardPlatformIconUrl = PlatformsApi.getPlatformIcon(selectedPlatform, platforms)
  const dashboardPlatformLabel = PlatformsApi.getPlatformDisplayName(selectedPlatform, platforms)

  return (
    <React.Fragment>
      <SEO
        title={applySEODate(PAGE_SEO.weeklyInsights.title)}
        description={PAGE_SEO.weeklyInsights.description}
        keywords={PAGE_SEO.weeklyInsights.keywords}
        canonical={generateCanonicalUrl('/weekly-insights')}
        robots={PAGE_SEO.weeklyInsights.robots}
        structuredData={[STRUCTURED_DATA.organization, STRUCTURED_DATA.website]}
      />
      <div className="page-content dashboard-responsive">
        <Container fluid>
          {/* Header Section — same shared header as Trending/New Release/etc. so the
              platform pills sit beside the title instead of on their own row below
              the description. Country/language pickers, filters and sort live per
              section further down (Top Discount, Most Popular, …), not up here. */}
          <Row className="mb-4">
            <Col>
              <InsightsPageHeader
                title={`Weekly ${platforms.find(p => p.id === selectedPlatform)?.display_name || 'Meta'} Insights`}
                description="Get a snapshot of the week's top-performing, trending, and newly released apps — all in one place. Discover insights by category, country, and language, and track app trends across multiple metrics powered by KeyQuest's custom analytics engine."
                platforms={platforms}
                platformsLoading={platformsLoading}
                selectedPlatform={selectedPlatform}
                onPlatformChange={handlePlatformChange}
              />
            </Col>
          </Row>

          {/* Section 1: Two-column Featured Game + Most Tracked */}
          <Row className="gx-4 gy-4">
            {/* Left Column - Top Discount (replaces the carousel) */}
            <Col xs={12} md={12} lg={6}>
              <div className="border rounded-3 p-3 p-lg-4 h-100 track_sec" style={{ backgroundColor: '#21222D', minHeight: 440 }}>
                <div style={{ height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }}>
                  <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h3 className="mb-0" style={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: '24px', color: "rgba(255, 255, 255, 1)" }}>
                      Top Discount
                    </h3>
                    <div className="d-flex align-items-center gap-2">
                      <Link
                        to="/top-discounts"
                        state={{ from: 'weekly-insights' }}
                        style={viewAllStyle}
                        onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEW_ALL_CLICKED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
                        })}
                      >
                        <span>View All</span>
                        <i className="fa fa-chevron-right" style={{ fontSize: '0.75rem' }} />
                      </Link>
                      <button type="button" onClick={() => setTopDiscountFilterPanelOpen(true)} style={filterBtnStyle}>
                        <i className="fa fa-filter" style={{ fontSize: '0.75rem' }} />
                        <span>Filters</span>
                      </button>
                    </div>
                  </div>

                  {/* Country / Language selectors for Top Discount — divider-before-
                      chevron look (this section's house style); Trending et al.
                      use the plain-chevron default instead, see FlagSelectDropdown. */}
                  <div className="mb-3 d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'nowrap' }}>
                    <FlagSelectDropdown
                      options={countryOptions}
                      value={topDiscountCountry}
                      loading={countriesLoading}
                      placeholder="Select Country"
                      onChange={(code) => {
                        const langForCountry = getLocalesForCountry(code)[0]?.value || topDiscountLanguage || null
                        setTopDiscountCountry(code)
                        setTopDiscountLanguage(langForCountry)
                        setTopDiscountPage(1)
                        try {
                          sessionStorage.setItem('topDiscount_selectedCountry', code)
                          if (langForCountry) sessionStorage.setItem('topDiscount_selectedLanguage', langForCountry)
                          else sessionStorage.removeItem('topDiscount_selectedLanguage')
                        } catch (e) { }
                        setTopDiscountLastUpdated(new Date())
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
                          country: code,
                          language: langForCountry,
                        })
                        // fetch updated Top Discount data for new selection
                        fetchTopDiscount(code, langForCountry, 1)
                      }}
                      icon={(code) => {
                        const FlagComp = flags[code]
                        return FlagComp ? <FlagComp style={{ width: '16px', height: 'auto' }} /> : null
                      }}
                    />

                    <FlagSelectDropdown
                      options={getLocalesForCountry(topDiscountCountry)}
                      value={topDiscountLanguage}
                      loading={countriesLoading}
                      placeholder="Select Language"
                      onChange={(val) => {
                        setTopDiscountLanguage(val)
                        setTopDiscountPage(1)
                        try { if (val) sessionStorage.setItem('topDiscount_selectedLanguage', val); else sessionStorage.removeItem('topDiscount_selectedLanguage') } catch (e) { }
                        setTopDiscountLastUpdated(new Date())
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
                          country: topDiscountCountry,
                          language: val,
                        })
                        // fetch updated Top Discount data for new selection
                        fetchTopDiscount(topDiscountCountry, val, 1)
                      }}
                      noOptionsText="Select a country first"
                    />
                  </div>

                  {Object.keys(topDiscountAppliedFilters || {}).length > 0 && (
                    <div style={{ marginTop: '8px', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {Object.entries(topDiscountAppliedFilters).map(([key, value]) => {
                        const displayVal = Array.isArray(value) ? value.join(', ') : (value === null || value === undefined || value === '' ? 'Any' : String(value))
                        return (
                          <span key={key} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 8px', background: 'linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12))', color: '#F6255A', borderRadius: '6px', fontSize: '12px', fontWeight: 500 }}>
                            <span style={{ textTransform: 'capitalize', marginRight: 4 }}>{key.replace(/_/g, ' ')}:</span>
                            <span style={{ opacity: 0.9, color: '#F6255A' }}>{displayVal}</span>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRemoveTopDiscountFilter(key);
                              }}
                              aria-label={`Remove filter ${key}`}
                              style={{ marginLeft: 4, background: 'transparent', border: 'none', color: '#F6255A', cursor: 'pointer', fontSize: 12, lineHeight: 0.9 }}
                            >
                              ×
                            </button>
                          </span>
                        )
                      })}
                    </div>
                  )}

                  {/* Timestamp */}
                  {topDiscountLastUpdated && (
                    <p style={{
                      fontSize: '12px',
                      color: '#E8E8E8',
                      opacity: 0.6,
                      marginBottom: '1.5rem'
                    }}>
                      Last updated: {topDiscountLastUpdated.toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                      })}
                    </p>
                  )}

                  {/* Coming soon placeholder (styled to mirror Most Popular cards) */}
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 12, marginTop: 0 }}>
                    {(loading || topDiscountLoading) ? (
                      isMobile ? (
                        <>
                          {[...Array(4)].map((_, i) => (
                            <Skeleton
                              key={i}
                              height={86}
                              className="mb-3"
                              borderRadius={10}
                              baseColor="#171821"
                              highlightColor="#2a2b37"
                              enableAnimation={true}
                            />
                          ))}
                        </>
                      ) : (
                        <SectionListSkeleton />
                      )
                      ) : (topDiscount && topDiscount.length > 0) ? (
                      // Mirror Most Popular: show paginated stacked TrackedGame cards (no Track button)
                      (() => {
                        const start = (topDiscountPage - 1) * mostPopularPageSize
                        const shown = (topDiscount || []).slice(start, start + mostPopularPageSize)
                        return shown.map((app, idx) => (
                          <Link
                            key={`td-${start + idx}`}
                            to={`/xr/app/${generateSlug(app.name || '')}?id=${app.item_id}`}
                            state={{ app_id: app.item_id, data: app, source_surface: "weekly_insight_top_discounts" }}
                            onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_APP_SELECTED, {
                              app_id: app.item_id,
                              app_name: app.name,
                              insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
                            })}
                            style={{ textDecoration: 'none', display: 'block', marginBottom: 12 }}
                          >
                            <TrackedGame trackedApp={app} showTrack={false} platformId={selectedPlatform} showPlatformName showPrice />
                          </Link>
                        ))
                      })()
                      ) : (
                      <div style={{ padding: 28 }}>
                        <div style={{ textAlign: 'center', color: '#A1ACB8', fontSize: 16 }}>
                          No data available for the selected country/language.
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Top Discount Pagination (mirror Most Popular: 4 per page) */}
                  {topDiscountTotal > mostPopularPageSize && (() => {
                    const pageSize = mostPopularPageSize
                    const totalPages = Math.ceil(topDiscountTotal / pageSize)
                    const visible = isMobile ? Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1) : getVisiblePages(totalPages, topDiscountPage, 5)

                    const goToPage = (newPage) => {
                      setTopDiscountPage(newPage)
                      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_DISCOUNTS,
                        page: newPage,
                      })
                      // client-side pagination since we have full array
                      // nothing else required because rendering slices `topDiscount`
                    }

                    return (
                      <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                        <button type="button" onClick={() => goToPage(Math.max(1, topDiscountPage - 1))} disabled={topDiscountPage <= 1} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.06)', color: topDiscountPage <= 1 ? 'rgba(255,255,255,0.35)' : '#fff', padding: '4px 8px', borderRadius: 4, fontSize: '12px', cursor: topDiscountPage <= 1 ? 'not-allowed' : 'pointer' }}>Prev</button>

                        {visible[0] > 1 && <span style={{ minWidth: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: '12px' }}>...</span>}

                        {visible.map((pageNum) => (
                          <button key={`td-pg-${pageNum}`} type="button" onClick={() => goToPage(pageNum)} style={{ minWidth: 28, height: 28, borderRadius: 4, border: '1px solid rgba(255,255,255,0.06)', background: topDiscountPage === pageNum ? '#ff2f6d' : 'transparent', color: topDiscountPage === pageNum ? '#fff' : 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: '12px', cursor: 'pointer' }}>{pageNum}</button>
                        ))}

                        {visible[visible.length - 1] < totalPages && <span style={{ minWidth: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: '12px' }}>...</span>}

                        <button type="button" onClick={() => goToPage(Math.min(totalPages, topDiscountPage + 1))} disabled={topDiscountPage >= totalPages} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.06)', color: topDiscountPage >= totalPages ? 'rgba(255,255,255,0.35)' : '#fff', padding: '4px 8px', borderRadius: 4, fontSize: '12px', cursor: topDiscountPage >= totalPages ? 'not-allowed' : 'pointer' }}>Next</button>
                      </div>
                    )
                  })()}
                </div>
              </div>
            </Col>

            {/* Right Column - Most Tracked Weekly Insights */}
            <Col xs={12} md={12} lg={6}>
              <div
                className="border rounded-3 p-3 p-lg-4 h-100 track_sec"
                style={{ backgroundColor: '#21222D', minHeight: 440 }}
              >
                <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                  <h3 className="mb-0" style={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: '24px', color: "rgba(255, 255, 255, 1)" }}>
                    Most Popular
                  </h3>
                  <div className="d-flex align-items-center gap-2">
                    <Link
                      to="/most-popular"
                      state={{ from: 'weekly-insights' }}
                      style={viewAllStyle}
                      onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEW_ALL_CLICKED, {
                        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
                      })}
                    >
                      <span>View All</span>
                      <i className="fa fa-chevron-right" style={{ fontSize: '0.75rem' }} />
                    </Link>
                    <button type="button" onClick={() => setFilterPanelOpen(true)} style={filterBtnStyle}>
                      <i className="fa fa-filter" style={{ fontSize: '0.75rem' }} />
                      <span>Filters</span>
                    </button>
                  </div>
                </div>

                {/* Country and Language Selectors */}
                <div className="mb-3 d-flex align-items-center gap-2"
                  style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'nowrap' }}>
                  <FlagSelectDropdown
                    options={countryOptions}
                    value={selectedCountry}
                    loading={countriesLoading}
                    placeholder="Select Country"
                    onChange={(code) => {
                      // pick default language for selected country if available
                      const langForCountry = getLocalesForCountry(code)[0]?.value || selectedLanguage || null
                      setSelectedCountry(code)
                      setSelectedLanguage(langForCountry)
                      try { sessionStorage.setItem('mostPopular_selectedCountry', code); sessionStorage.setItem('mostPopular_selectedLanguage', langForCountry || ''); } catch (e) { }
                      setCurrentPage(1)
                      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
                        country: code,
                        language: langForCountry,
                      })
                      fetchMostPopular(appliedFilters, code, langForCountry, 1)
                    }}
                    icon={(code) => {
                      const FlagComp = flags[code]
                      return FlagComp ? <FlagComp style={{ width: '16px', height: 'auto' }} /> : null
                    }}
                  />

                  <FlagSelectDropdown
                    options={getLocalesForCountry(selectedCountry)}
                    value={selectedLanguage}
                    loading={countriesLoading}
                    placeholder="Select Language"
                    onChange={(val) => {
                      setSelectedLanguage(val)
                      try { sessionStorage.setItem('mostPopular_selectedLanguage', val || ''); } catch (e) { }
                      setCurrentPage(1)
                      trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                        insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
                        country: selectedCountry,
                        language: val,
                      })
                      fetchMostPopular(appliedFilters, selectedCountry, val, 1)
                    }}
                    noOptionsText="Select a country first"
                  />
                </div>
                {/* Active Filter Badges */}
                {Object.keys(appliedFilters).length > 0 && (
                  <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {Object.entries(appliedFilters).map(([key, value]) => {
                      if (!value || (Array.isArray(value) && value.length === 0)) return null
                      const displayValue = Array.isArray(value) ? value.join(', ') : value
                      return (
                        <span key={key} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 8px', background: 'linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12))', color: '#F6255A', borderRadius: '6px', fontSize: '12px', fontWeight: 500 }}>
                          <span style={{ textTransform: 'capitalize', marginRight: 4 }}>{key.replace(/_/g, ' ')}:</span>
                          <span style={{ opacity: 0.9, color: '#F6255A' }}>{displayValue}</span>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleRemoveMostPopularFilter(key);
                            }}
                            aria-label={`Remove filter ${key}`}
                            style={{
                              marginLeft: 4,
                              background: 'transparent',
                              border: 'none',
                              color: '#F6255A',
                              cursor: 'pointer',
                              fontSize: 12,
                              lineHeight: 0.9
                            }}
                          >
                            ×
                          </button>
                        </span>
                      )
                    })}
                  </div>
                )}

                {mostPopularLastUpdated && (
                  <p style={{
                    fontSize: '12px',
                    color: '#E8E8E8',
                    opacity: 0.6,
                    marginBottom: '1.5rem'
                  }}>
                    Last updated: {mostPopularLastUpdated.toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit'
                    })}
                  </p>
                )}

                {(loading || mostPopularLoading) ? (
                  isMobile ? (
                    <>
                      {[...Array(4)].map((_, i) => (
                        <Skeleton
                          key={i}
                          height={86}
                          className="mb-3"
                          borderRadius={10}
                          baseColor="#171821"
                          highlightColor="#2a2b37"
                          enableAnimation={true}
                        />
                      ))}
                    </>
                  ) : (
                    <SectionListSkeleton />
                  )
                ) : (
                  <>
                    {/* Most Popular - render using TrackedGame (mirror OptimizedDashboard) */}
                    {mostPopular && mostPopular.length > 0 ? (
                      isMobile ? (
                        displayedMostPopular.map((app, idx) => (
                          <Link
                            key={`popular-${app.item_id}-${idx}`}
                            to={`/xr/app/${generateSlug(app.name || '')}?id=${app.item_id}`}
                            state={{ app_id: app.item_id, data: app, source_surface: "weekly_insight_popular" }}
                            onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_APP_SELECTED, {
                              app_id: app.item_id,
                              app_name: app.name,
                              insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
                            })}
                            style={{ textDecoration: "none", display: 'block', marginBottom: isMobile ? 12 : 16 }}
                          >
                            <div className="w-100 track_game_boxes mb-3" style={{
                              padding: "16px",
                              borderRadius: "10px",
                              background: "#171821",
                              boxShadow: "0px 4px 8px 0px #00000033",
                              transition: "background 0.3s ease"
                            }}
                              onMouseEnter={(e) => e.currentTarget.style.background = "#1f202b"}
                              onMouseLeave={(e) => e.currentTarget.style.background = "#171821"}
                            >
                              <div className="d-flex flex-row flex-wrap w-100 border-0 align-items-start">
                                <CardImg
                                  src={app?.image_url || "https://via.placeholder.com/100"}
                                  alt="Game Image"
                                  className="me-3"
                                  style={{
                                    width: "55px",
                                    height: "55px",
                                    minWidth: "54px",
                                    minHeight: "54px",
                                    maxWidth: "80px",
                                    maxHeight: "80px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    flexShrink: 0,
                                  }}
                                />
                                <div className="p-0 me-3" style={{
                                  flex: 1,
                                  minWidth: 0,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                }}>
                                  <div style={{
                                    fontFamily: "Rubik",
                                    fontWeight: 600,
                                    fontSize: "16px",
                                    lineHeight: "1.5",
                                    color: "#ffffff",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    paddingBottom: "8px",
                                  }}>
                                    {app.name}
                                  </div>
                                  <div style={{
                                    fontFamily: "Rubik",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    color: "#ffffffcc",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    flexWrap: "wrap",
                                  }}>
                                    <span>{app?.category || ''}</span>
                                    {dashboardPlatformIconUrl && (
                                      <span style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                        <img
                                          src={dashboardPlatformIconUrl}
                                          alt={dashboardPlatformLabel || selectedPlatform}
                                          style={{ width: "18px", height: "18px", objectFit: "contain" }}
                                          onError={(e) => { e.target.style.display = 'none' }}
                                        />
                                        {dashboardPlatformLabel && <span>{dashboardPlatformLabel}</span>}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Link>
                        ))
                      ) : (
                        // Desktop: show up to 4 smaller TrackedGame cards in a single column (one after another)
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                          {(displayedMostPopular || []).slice(0, mostPopularPageSize).map((app, idx) => (
                            <Link
                              key={`popular-${app.item_id}-${idx}`}
                              to={`/xr/app/${generateSlug(app.name || '')}?id=${app.item_id}`}
                              state={{ app_id: app.item_id, data: app, source_surface: "weekly_insight_popular" }}
                              onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_APP_SELECTED, {
                                app_id: app.item_id,
                                app_name: app.name,
                                insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
                              })}
                              style={{ textDecoration: 'none', display: 'block', marginBottom: isMobile ? 12 : 16 }}
                            >
                              <TrackedGame trackedApp={app} showTrack={false} platformId={selectedPlatform} showPlatformName />
                            </Link>
                          ))}
                        </div>
                      )
                    ) : (
                      <div style={{ padding: 28 }}>
                        <div style={{ textAlign: 'center', color: '#A1ACB8', fontSize: 16 }}>
                          No data available for the selected country/language.
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* Pagination (Most Popular: 4 per page on all devices) */}
                {totalItems > mostPopularPageSize && (() => {
                  const pageSize = mostPopularPageSize
                  const totalPages = Math.ceil(totalItems / pageSize)
                  // Mobile: keep pagination compact — show 1,2,3 then ellipsis if more pages
                  const visible = isMobile ? Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1) : getVisiblePages(totalPages, currentPage, 5)

                  const goToPage = (newPage) => {
                    const start = (newPage - 1) * pageSize
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.POPULAR,
                      page: newPage,
                    })
                    if (mostPopularAll && mostPopularAll.length > 0) {
                      setMostPopular(mostPopularAll.slice(start, start + pageSize))
                      setCurrentPage(newPage)
                    } else {
                      // map client page to server page (server uses `itemsPerPage`)
                      const serverPage = Math.floor(start / itemsPerPage) + 1
                      setCurrentPage(newPage)
                      fetchMostPopular(appliedFilters, selectedCountry, selectedLanguage, serverPage)
                    }
                  }

                  // Desktop
                  return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 10, flexWrap: 'wrap' }}>
                      <button type="button" onClick={() => goToPage(Math.max(1, currentPage - 1))} disabled={currentPage <= 1} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.06)', color: currentPage <= 1 ? 'rgba(255,255,255,0.35)' : '#fff', padding: '4px 8px', borderRadius: 4, fontSize: '12px', cursor: currentPage <= 1 ? 'not-allowed' : 'pointer' }}>Prev</button>

                      {visible[0] > 1 && <span style={{ minWidth: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: '12px' }}>...</span>}

                      {visible.map((pageNum) => (
                        <button key={`pg-${pageNum}`} type="button" onClick={() => goToPage(pageNum)} style={{ minWidth: 28, height: 28, borderRadius: 4, border: '1px solid rgba(255,255,255,0.06)', background: currentPage === pageNum ? '#ff2f6d' : 'transparent', color: currentPage === pageNum ? '#fff' : 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: '12px', cursor: 'pointer' }}>{pageNum}</button>
                      ))}

                      {visible[visible.length - 1] < totalPages && <span style={{ minWidth: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: '12px' }}>...</span>}

                      <button type="button" onClick={() => goToPage(Math.min(totalPages, currentPage + 1))} disabled={currentPage >= totalPages} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.06)', color: currentPage >= totalPages ? 'rgba(255,255,255,0.35)' : '#fff', padding: '4px 8px', borderRadius: 4, fontSize: '12px', cursor: currentPage >= totalPages ? 'not-allowed' : 'pointer' }}>Next</button>
                    </div>
                  )
                })()}

              </div>
            </Col>
          </Row>

          {/* Section 1: Top Trending Games */}
          <div
            className="mt-4 w-100"
            style={{
              background: '#21222D',
              border: '1px solid #353748',
              borderRadius: '8px',
              width: isMobile ? '100%' : 'calc(100% - 300px)',
              margin: isMobile ? undefined : '0 auto',
              marginTop: isMobile ? undefined : 12
            }}
          >
            <div className="rounded-3 p-4" style={{ backgroundColor: '#21222D', minHeight: 360 }}>
              <h3 className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <span style={{ fontFamily: 'Rubik', fontWeight: 600, fontSize: '24px', color: "rgba(255, 255, 255, 1)" }}>
                  Top Trending Games
                </span>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <Link
                    to="/trending"
                    state={{ from: 'weekly-insights' }}
                    style={viewAllStyle}
                    onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEW_ALL_CLICKED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
                    })}
                  >
                    <span>View All</span>
                    <i className="fa fa-chevron-right" style={{ fontSize: '0.75rem' }} />
                  </Link>
                  <button type="button" onClick={() => setTrendingFilterPanelOpen(true)} style={filterBtnStyle}>
                    <i className="fa fa-filter" style={{ fontSize: '0.75rem' }} />
                    <span>Filters</span>
                  </button>
                </div>
              </h3>

              {/* Country and Language Selectors (Trending) */}
              <div className="mb-3 d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'nowrap' }}>
                <FlagSelectDropdown
                  options={countryOptions}
                  value={trendingCountry}
                  loading={countriesLoading}
                  placeholder="Select Country"
                  onChange={(code) => {
                    const langForCountry = getLocalesForCountry(code)[0]?.value || trendingLanguage || null
                    setTrendingCountry(code)
                    setTrendingLanguage(langForCountry)
                    try { sessionStorage.setItem('trending_selectedCountry', code); sessionStorage.setItem('trending_selectedLanguage', langForCountry || ''); } catch (e) { }
                    setTrendingPage(1)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
                      country: code,
                      language: langForCountry,
                    })
                    fetchTrendingApps(code, langForCountry, 1, trendingAppliedFilters)
                  }}
                  icon={(code) => {
                    const FlagComp = flags[code]
                    return FlagComp ? <FlagComp style={{ width: '16px', height: 'auto' }} /> : null
                  }}
                />

                <FlagSelectDropdown
                  options={getLocalesForCountry(trendingCountry)}
                  value={trendingLanguage}
                  loading={countriesLoading}
                  placeholder="Select Language"
                  onChange={(val) => {
                    setTrendingLanguage(val)
                    try { sessionStorage.setItem('trending_selectedLanguage', val || ''); } catch (e) { }
                    setTrendingPage(1)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
                      country: trendingCountry,
                      language: val,
                    })
                    fetchTrendingApps(trendingCountry, val, 1, trendingAppliedFilters)
                  }}
                  noOptionsText="Select a country first"
                />
              </div>

              {/* Timestamp */}
              {Object.keys(trendingAppliedFilters || {}).length > 0 && (
                <div style={{ marginTop: '8px', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {Object.entries(trendingAppliedFilters).map(([key, value]) => {
                    const displayVal = Array.isArray(value) ? value.join(', ') : (value === null || value === undefined || value === '' ? 'Any' : String(value))
                    return (
                      <span key={key} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 8px', background: 'linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12))', color: '#F6255A', borderRadius: '6px', fontSize: '12px', fontWeight: 500 }}>
                        <span style={{ textTransform: 'capitalize', marginRight: 4 }}>{key.replace(/_/g, ' ')}:</span>
                        <span style={{ opacity: 0.9, color: '#F6255A' }}>{displayVal}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleRemoveTrendingFilter(key);
                          }}
                          aria-label={`Remove filter ${key}`}
                          style={{ marginLeft: 4, background: 'transparent', border: 'none', color: '#F6255A', cursor: 'pointer', fontSize: 12, lineHeight: 0.9 }}
                        >
                          ×
                        </button>
                      </span>
                    )
                  })}
                </div>
              )}

              {trendingLastUpdated && (
                <p style={{
                  fontSize: '12px',
                  color: '#E8E8E8',
                  opacity: 0.6,
                  marginBottom: '1rem'
                }}>
                  Last updated: {trendingLastUpdated.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}
                </p>
              )}

              <Row className="trending_slider">
                {loading ? (
                  // overall dashboard loading (initial load)
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{ padding: isMobile ? '0 12px' : '0 8px', boxSizing: 'border-box', flex: '1 0 200px' }}
                    >
                      <Skeleton
                        height={250}
                        borderRadius={8}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginTop: '12px' }}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                    </div>
                  ))
                ) : trendingLoading ? (
                  // section-specific loading
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{ padding: isMobile ? '0 12px' : '0 8px', boxSizing: 'border-box', flex: '1 0 200px' }}
                    >
                      <Skeleton
                        height={250}
                        borderRadius={8}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginTop: '12px' }}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                    </div>
                  ))
                ) : (trendingApps && trendingApps.length > 0) ? (
                  <CarouselComponent key="trendingCarousel" game={trendingApps} title="Trending" insightType={ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING} slidesToShowOverride={8} />
                ) : (
                  <div style={{ padding: 28 }}>
                    <div style={{ textAlign: 'center', color: '#A1ACB8', fontSize: 16 }}>
                      {Object.keys(trendingAppliedFilters || {}).length > 0 ? 'No results matched with filter.' : 'No data available for the selected country/language.'}
                    </div>
                  </div>
                )}
              </Row>

              {/* Pagination for Trending */}
              {trendingTotal > trendingPerPage && (() => {
                const totalPages = Math.ceil(trendingTotal / trendingPerPage)
                const visible = isMobile ? Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1) : getVisiblePages(totalPages, trendingPage, 5)
                return (
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: isMobile ? 16 : 35 }}>
                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.max(1, trendingPage - 1)
                        setTrendingPage(newPage)
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
                          page: newPage,
                        })
                        if (trendingAll && trendingAll.length > 0) {
                          const start = (newPage - 1) * trendingPerPage
                          setTrendingApps(trendingAll.slice(start, start + trendingPerPage))
                        } else {
                          fetchTrendingApps(trendingCountry, trendingLanguage, newPage, trendingAppliedFilters)
                        }
                      }}
                      disabled={trendingPage <= 1}
                      style={{
                        background: 'transparent',
                        border: '1px solid rgba(255,255,255,0.06)',
                        color: trendingPage <= 1 ? 'rgba(255,255,255,0.35)' : '#fff',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: '12px',
                        cursor: trendingPage <= 1 ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Prev
                    </button>

                    {visible[0] > 1 && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px', color: '#fff' }}>...</span>
                    )}

                    {visible.map((pageNum) => (
                      <button
                        key={`trending-pg-${pageNum}`}
                        type="button"
                        onClick={() => {
                          setTrendingPage(pageNum)
                          trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                            insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
                            page: pageNum,
                          })
                          if (trendingAll && trendingAll.length > 0) {
                            const start = (pageNum - 1) * trendingPerPage
                            setTrendingApps(trendingAll.slice(start, start + trendingPerPage))
                          } else {
                            fetchTrendingApps(trendingCountry, trendingLanguage, pageNum, trendingAppliedFilters)
                          }
                        }}
                        style={{
                          minWidth: 28,
                          height: 28,
                          borderRadius: 4,
                          border: '1px solid rgba(255,255,255,0.06)',
                          background: trendingPage === pageNum ? '#ff2f6d' : 'transparent',
                          color: trendingPage === pageNum ? '#fff' : 'rgba(255,255,255,0.8)',
                          fontWeight: 600,
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        {pageNum}
                      </button>
                    ))}

                    {visible[visible.length - 1] < totalPages && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px', color: '#fff' }}>...</span>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.min(totalPages, trendingPage + 1)
                        setTrendingPage(newPage)
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TRENDING,
                          page: newPage,
                        })
                        if (trendingAll && trendingAll.length > 0) {
                          const start = (newPage - 1) * trendingPerPage
                          setTrendingApps(trendingAll.slice(start, start + trendingPerPage))
                        } else {
                          fetchTrendingApps(trendingCountry, trendingLanguage, newPage, trendingAppliedFilters)
                        }
                      }}
                      disabled={trendingPage >= totalPages}
                      style={{
                        background: 'transparent',
                        border: '1px solid rgba(255,255,255,0.06)',
                        color: trendingPage >= totalPages ? 'rgba(255,255,255,0.35)' : '#fff',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: '12px',
                        cursor: trendingPage >= totalPages ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Next
                    </button>
                  </div>
                )
              })()}
            </div>
          </div>

          {/* Section 2: New Releases */}
          <div
            className="mt-3 mt-lg-4 w-100"
            style={{
              background: '#21222D',
              border: '1px solid #353748',
              borderRadius: '8px',
              width: isMobile ? '100%' : 'calc(100% - 300px)',
              margin: isMobile ? undefined : '0 auto',
              marginTop: isMobile ? undefined : 8
            }}
          >
            <div className="border rounded-3 p-3 p-lg-4" style={{ backgroundColor: '#21222D', minHeight: 360 }}>
              <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <h3
                  className="mb-0"
                  style={{
                    fontFamily: 'Rubik',
                    fontWeight: 600,
                    fontSize: 'clamp(18px, 4vw, 24px)',
                    color: "rgba(255, 255, 255, 1)"
                  }}
                >
                  New Releases
                </h3>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <Link
                    to="/new-releases"
                    state={{ from: 'weekly-insights' }}
                    className="d-none d-md-flex"
                    style={viewAllStyle}
                    onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEW_ALL_CLICKED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
                    })}
                  >
                    <span>View All</span>
                    <i className="fa fa-chevron-right" style={{ fontSize: '0.75rem' }} />
                  </Link>
                  <button type="button" onClick={() => setNewReleasesFilterPanelOpen(true)} style={filterBtnStyle}>
                    <i className="fa fa-filter" style={{ fontSize: '0.75rem' }} />
                    <span>Filters</span>
                  </button>
                </div>
              </div>

              {/* Country and Language Selectors (New Releases) */}
              <div className="mb-3 d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'nowrap' }}>
                <FlagSelectDropdown
                  options={countryOptions}
                  value={newReleasesCountry}
                  loading={countriesLoading}
                  placeholder="Select Country"
                  onChange={(code) => {
                    const langForCountry = getLocalesForCountry(code)[0]?.value || newReleasesLanguage || null
                    setNewReleasesCountry(code)
                    setNewReleasesLanguage(langForCountry)
                    try { sessionStorage.setItem('newReleases_selectedCountry', code); sessionStorage.setItem('newReleases_selectedLanguage', langForCountry || ''); } catch (e) { }
                    setNewReleasesPage(1)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
                      country: code,
                      language: langForCountry,
                    })
                    fetchNewReleases(code, langForCountry, 1, newReleasesAppliedFilters)
                  }}
                  icon={(code) => {
                    const FlagComp = flags[code]
                    return FlagComp ? <FlagComp style={{ width: '16px', height: 'auto' }} /> : null
                  }}
                />

                <FlagSelectDropdown
                  options={getLocalesForCountry(newReleasesCountry)}
                  value={newReleasesLanguage}
                  loading={countriesLoading}
                  placeholder="Select Language"
                  onChange={(val) => {
                    setNewReleasesLanguage(val)
                    try { sessionStorage.setItem('newReleases_selectedLanguage', val || ''); } catch (e) { }
                    setNewReleasesPage(1)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
                      country: newReleasesCountry,
                      language: val,
                    })
                    fetchNewReleases(newReleasesCountry, val, 1, newReleasesAppliedFilters)
                  }}
                  noOptionsText="Select a country first"
                />
              </div>

              {/* Timestamp */}
              {Object.keys(newReleasesAppliedFilters || {}).length > 0 && (
                <div style={{ marginTop: '8px', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {Object.entries(newReleasesAppliedFilters).map(([key, value]) => {
                    const displayVal = Array.isArray(value) ? value.join(', ') : (value === null || value === undefined || value === '' ? 'Any' : String(value))
                    return (
                      <span key={key} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 8px', background: 'linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12))', color: '#F6255A', borderRadius: '6px', fontSize: '12px', fontWeight: 500 }}>
                        <span style={{ textTransform: 'capitalize', marginRight: 4 }}>{key.replace(/_/g, ' ')}:</span>
                        <span style={{ opacity: 0.9, color: '#F6255A' }}>{displayVal}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleRemoveNewReleasesFilter(key);
                          }}
                          aria-label={`Remove filter ${key}`}
                          style={{ marginLeft: 4, background: 'transparent', border: 'none', color: '#F6255A', cursor: 'pointer', fontSize: 12, lineHeight: 0.9 }}
                        >
                          ×
                        </button>
                      </span>
                    )
                  })}
                </div>
              )}

              {newReleasesLastUpdated && (
                <p style={{
                  fontSize: '12px',
                  color: '#E8E8E8',
                  opacity: 0.6,
                  marginBottom: '1rem'
                }}>
                  Last updated: {newReleasesLastUpdated.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}
                </p>
              )}

              <Row className="newreleases_slider">
                {loading ? (
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{ padding: isMobile ? '0 12px' : '0 8px', boxSizing: 'border-box', flex: '1 0 200px' }}
                    >
                      <Skeleton
                        height={250}
                        borderRadius={8}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginTop: '12px' }}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                    </div>
                  ))
                ) : newReleasesLoading ? (
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{ padding: isMobile ? '0 12px' : '0 8px', boxSizing: 'border-box', flex: '1 0 200px' }}
                    >
                      <Skeleton
                        height={250}
                        borderRadius={8}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginTop: '12px' }}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                    </div>
                  ))
                ) : (newReleases && newReleases.length > 0) ? (
                  <CarouselComponent key="newReleaseCarousel" game={newReleases} title="New Releases" insightType={ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE} slidesToShowOverride={8} />
                ) : (
                  <div style={{ padding: 28 }}>
                    <div style={{ textAlign: 'center', color: '#A1ACB8', fontSize: 16 }}>
                      {Object.keys(newReleasesAppliedFilters || {}).length > 0 ? 'No results matched with filter.' : 'No data available for the selected country/language.'}
                    </div>
                  </div>
                )}
              </Row>

              {/* Pagination for New Releases */}
              {newReleasesTotal > newReleasesPerPage && (() => {
                const totalPages = Math.ceil(newReleasesTotal / newReleasesPerPage)
                const visible = isMobile ? Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1) : getVisiblePages(totalPages, newReleasesPage, 5)
                return (
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: isMobile ? 16 : 35 }}>
                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.max(1, newReleasesPage - 1)
                        setNewReleasesPage(newPage)
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
                          page: newPage,
                        })
                        if (newReleasesAll && newReleasesAll.length > 0) {
                          const start = (newPage - 1) * newReleasesPerPage
                          setNewReleases(newReleasesAll.slice(start, start + newReleasesPerPage))
                        } else {
                          fetchNewReleases(newReleasesCountry, newReleasesLanguage, newPage, newReleasesAppliedFilters)
                        }
                      }}
                      disabled={newReleasesPage <= 1}
                      style={{
                        background: 'transparent',
                        border: '1px solid rgba(255,255,255,0.06)',
                        color: newReleasesPage <= 1 ? 'rgba(255,255,255,0.35)' : '#fff',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: '12px',
                        cursor: newReleasesPage <= 1 ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Prev
                    </button>

                    {visible[0] > 1 && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px', color: '#fff' }}>...</span>
                    )}

                    {visible.map((pageNum) => (
                      <button
                        key={`newreleases-pg-${pageNum}`}
                        type="button"
                        onClick={() => {
                          setNewReleasesPage(pageNum)
                          trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                            insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
                            page: pageNum,
                          })
                          if (newReleasesAll && newReleasesAll.length > 0) {
                            const start = (pageNum - 1) * newReleasesPerPage
                            setNewReleases(newReleasesAll.slice(start, start + newReleasesPerPage))
                          } else {
                            fetchNewReleases(newReleasesCountry, newReleasesLanguage, pageNum, newReleasesAppliedFilters)
                          }
                        }}
                        style={{
                          minWidth: 28,
                          height: 28,
                          borderRadius: 4,
                          border: '1px solid rgba(255,255,255,0.06)',
                          background: newReleasesPage === pageNum ? '#ff2f6d' : 'transparent',
                          color: newReleasesPage === pageNum ? '#fff' : 'rgba(255,255,255,0.8)',
                          fontWeight: 600,
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        {pageNum}
                      </button>
                    ))}

                    {visible[visible.length - 1] < totalPages && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px', color: '#fff' }}>...</span>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.min(totalPages, newReleasesPage + 1)
                        setNewReleasesPage(newPage)
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.NEW_RELEASE,
                          page: newPage,
                        })
                        if (newReleasesAll && newReleasesAll.length > 0) {
                          const start = (newPage - 1) * newReleasesPerPage
                          setNewReleases(newReleasesAll.slice(start, start + newReleasesPerPage))
                        } else {
                          fetchNewReleases(newReleasesCountry, newReleasesLanguage, newPage, newReleasesAppliedFilters)
                        }
                      }}
                      disabled={newReleasesPage >= totalPages}
                      style={{
                        background: 'transparent',
                        border: '1px solid rgba(255,255,255,0.06)',
                        color: newReleasesPage >= totalPages ? 'rgba(255,255,255,0.35)' : '#fff',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: '12px',
                        cursor: newReleasesPage >= totalPages ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Next
                    </button>
                  </div>
                )
              })()}
            </div>
          </div>

          {/* Section 3: Top Earners */}
          <div
            className="mt-3 mt-lg-4 w-100"
            style={{
              background: '#21222D',
              border: '1px solid #353748',
              borderRadius: '8px',
              width: isMobile ? '100%' : 'calc(100% - 300px)',
              margin: isMobile ? undefined : '0 auto',
              marginTop: isMobile ? undefined : 8
            }}
          >
            <div className="border rounded-3 p-3 p-lg-4" style={{ backgroundColor: '#21222D', minHeight: 360 }}>
              <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
                <h3
                  className="mb-0"
                  style={{
                    fontFamily: 'Rubik',
                    fontWeight: 600,
                    fontSize: 'clamp(18px, 4vw, 24px)',
                    color: "rgba(255, 255, 255, 1)"
                  }}
                >
                  Top Earners
                </h3>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <Link
                    to="/top-apps"
                    state={{ from: 'weekly-insights' }}
                    className="d-none d-md-flex"
                    style={viewAllStyle}
                    onClick={() => trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_VIEW_ALL_CLICKED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
                    })}
                  >
                    <span>View All</span>
                    <i className="fa fa-chevron-right" style={{ fontSize: '0.75rem' }} />
                  </Link>
                  <button type="button" onClick={() => setTopEarningFilterPanelOpen(true)} style={filterBtnStyle}>
                    <i className="fa fa-filter" style={{ fontSize: '0.75rem' }} />
                    <span>Filters</span>
                  </button>
                </div>
              </div>

              {/* Country and Language Selectors (Top Earners) */}
              <div className="mb-3 d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'nowrap' }}>
                <FlagSelectDropdown
                  options={countryOptions}
                  value={topEarningCountry}
                  loading={countriesLoading}
                  placeholder="Select Country"
                  onChange={(code) => {
                    const langForCountry = getLocalesForCountry(code)[0]?.value || topEarningLanguage || null
                    setTopEarningCountry(code)
                    setTopEarningLanguage(langForCountry)
                    setTopEarningPage(1)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
                      country: code,
                      language: langForCountry,
                    })
                    fetchTopEarning(code, langForCountry, 1, topEarningAppliedFilters)
                  }}
                  icon={(code) => {
                    const FlagComp = flags[code]
                    return FlagComp ? <FlagComp style={{ width: '16px', height: 'auto' }} /> : null
                  }}
                />

                <FlagSelectDropdown
                  options={getLocalesForCountry(topEarningCountry)}
                  value={topEarningLanguage}
                  loading={countriesLoading}
                  placeholder="Select Language"
                  onChange={(val) => {
                    setTopEarningLanguage(val)
                    try { sessionStorage.setItem('topEarning_selectedLanguage', val || ''); } catch (e) { }
                    setTopEarningPage(1)
                    trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_LOCALE_CHANGED, {
                      insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
                      country: topEarningCountry,
                      language: val,
                    })
                    fetchTopEarning(topEarningCountry, val, 1, topEarningAppliedFilters)
                  }}
                  noOptionsText="Select a country first"
                />
              </div>

              {/* Timestamp */}
              {Object.keys(topEarningAppliedFilters || {}).length > 0 && (
                <div style={{ marginTop: '8px', marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {Object.entries(topEarningAppliedFilters).map(([key, value]) => {
                    const displayVal = Array.isArray(value) ? value.join(', ') : (value === null || value === undefined || value === '' ? 'Any' : String(value))
                    return (
                      <span key={key} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 8px', background: 'linear-gradient(90deg, rgba(255,154,184,0.12), rgba(246,37,90,0.12))', color: '#F6255A', borderRadius: '6px', fontSize: '12px', fontWeight: 500 }}>
                        <span style={{ textTransform: 'capitalize', marginRight: 4 }}>{key.replace(/_/g, ' ')}:</span>
                        <span style={{ opacity: 0.9, color: '#F6255A' }}>{displayVal}</span>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleRemoveTopEarningFilter(key);
                          }}
                          aria-label={`Remove filter ${key}`}
                          style={{ marginLeft: 4, background: 'transparent', border: 'none', color: '#F6255A', cursor: 'pointer', fontSize: 12, lineHeight: 0.9 }}
                        >
                          ×
                        </button>
                      </span>
                    )
                  })}
                </div>
              )}

              {topEarningLastUpdated && (
                <p style={{
                  fontSize: '12px',
                  color: '#E8E8E8',
                  opacity: 0.6,
                  marginBottom: '1rem'
                }}>
                  Last updated: {topEarningLastUpdated.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  })}
                </p>
              )}

              <Row className="newreleases_slider">
                {loading ? (
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{ padding: isMobile ? '0 12px' : '0 8px', boxSizing: 'border-box', flex: '1 0 200px' }}
                    >
                      <Skeleton
                        height={250}
                        borderRadius={8}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginTop: '12px' }}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                    </div>
                  ))
                ) : topEarningLoading ? (
                  Array.from({ length: 5 }).map((_, idx) => (
                    <div
                      key={idx}
                      style={{ padding: isMobile ? '0 12px' : '0 8px', boxSizing: 'border-box', flex: '1 0 200px' }}
                    >
                      <Skeleton
                        height={250}
                        borderRadius={8}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                      <Skeleton
                        width="70%"
                        height={16}
                        style={{ marginTop: '12px' }}
                        baseColor="#171821"
                        highlightColor="#2a2b37"
                        enableAnimation={true}
                      />
                    </div>
                  ))
                ) : (topEarning && topEarning.length > 0) ? (
                  <CarouselComponent key="topEarningCarousel" game={topEarning} title="Top Earners" insightType={ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING} slidesToShowOverride={8} />
                ) : (
                  <div style={{ padding: 28 }}>
                    <div style={{ textAlign: 'center', color: '#A1ACB8', fontSize: 16 }}>
                      {Object.keys(topEarningAppliedFilters || {}).length > 0 ? 'No results matched with filter.' : 'No data available for the selected country/language.'}
                    </div>
                  </div>
                )}
              </Row>

              {/* Pagination for Top Earners */}
              {topEarningTotal > topEarningPerPage && (() => {
                const totalPages = Math.ceil(topEarningTotal / topEarningPerPage)
                const visible = isMobile ? Array.from({ length: Math.min(3, totalPages) }, (_, i) => i + 1) : getVisiblePages(totalPages, topEarningPage, 5)
                return (
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: isMobile ? 16 : 35 }}>
                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.max(1, topEarningPage - 1)
                        setTopEarningPage(newPage)
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
                          page: newPage,
                        })
                        fetchTopEarning(topEarningCountry, topEarningLanguage, newPage, topEarningAppliedFilters)
                      }}
                      disabled={topEarningPage <= 1}
                      style={{
                        background: 'transparent',
                        border: '1px solid rgba(255,255,255,0.06)',
                        color: topEarningPage <= 1 ? 'rgba(255,255,255,0.35)' : '#fff',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: '12px',
                        cursor: topEarningPage <= 1 ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Prev
                    </button>

                    {visible[0] > 1 && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px', color: '#fff' }}>...</span>
                    )}

                    {visible.map((pageNum) => (
                      <button
                        key={`topearning-pg-${pageNum}`}
                        type="button"
                        onClick={() => {
                          setTopEarningPage(pageNum)
                          trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                            insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
                            page: pageNum,
                          })
                          fetchTopEarning(topEarningCountry, topEarningLanguage, pageNum, topEarningAppliedFilters)
                        }}
                        style={{
                          minWidth: 28,
                          height: 28,
                          borderRadius: 4,
                          border: '1px solid rgba(255,255,255,0.06)',
                          background: topEarningPage === pageNum ? '#ff2f6d' : 'transparent',
                          color: topEarningPage === pageNum ? '#fff' : 'rgba(255,255,255,0.8)',
                          fontWeight: 600,
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        {pageNum}
                      </button>
                    ))}

                    {visible[visible.length - 1] < totalPages && (
                      <span style={{ display: 'inline-flex', alignItems: 'center', padding: '0 8px', color: '#fff' }}>...</span>
                    )}

                    <button
                      type="button"
                      onClick={() => {
                        const newPage = Math.min(totalPages, topEarningPage + 1)
                        setTopEarningPage(newPage)
                        trackEvent(ANALYTICS_EVENTS.FEATURE.WEEKLY_INSIGHT_PAGINATED, {
                          insight_type: ANALYTICS_EVENTS.WEEKLY_INSIGHT_TYPES.TOP_EARNING,
                          page: newPage,
                        })
                        fetchTopEarning(topEarningCountry, topEarningLanguage, newPage, topEarningAppliedFilters)
                      }}
                      disabled={topEarningPage >= totalPages}
                      style={{
                        background: 'transparent',
                        border: '1px solid rgba(255,255,255,0.06)',
                        color: topEarningPage >= totalPages ? 'rgba(255,255,255,0.35)' : '#fff',
                        padding: '4px 8px',
                        borderRadius: 4,
                        fontSize: '12px',
                        cursor: topEarningPage >= totalPages ? 'not-allowed' : 'pointer'
                      }}
                    >
                      Next
                    </button>
                  </div>
                )
              })()}
            </div>
          </div>
        </Container>
      </div>

      {/* Filter Panel */}
      <FilterPanel
        open={filterPanelOpen}
        sections={filterSections.length > 0 ? filterSections : undefined}
        // Platform is already selectable via the Meta Quest/Steam tabs above -
        // don't duplicate it inside the filter panel.
        hidePlatformSection
        onClose={() => setFilterPanelOpen(false)}
        onApply={handleFilterApply}
        initialValues={appliedFilters}
      />

      {/* Trending Filter Panel */}
      <FilterPanel
        open={trendingFilterPanelOpen}
        sections={filterSections.length > 0 ? filterSections : undefined}
        // Platform is already selectable via the Meta Quest/Steam tabs above -
        // don't duplicate it inside the filter panel.
        hidePlatformSection
        onClose={() => setTrendingFilterPanelOpen(false)}
        onApply={handleTrendingFilterApply}
        initialValues={trendingAppliedFilters}
      />

      {/* New Releases Filter Panel */}
      <FilterPanel
        open={newReleasesFilterPanelOpen}
        sections={filterSections.length > 0 ? filterSections : undefined}
        // Platform is already selectable via the Meta Quest/Steam tabs above -
        // don't duplicate it inside the filter panel.
        hidePlatformSection
        onClose={() => setNewReleasesFilterPanelOpen(false)}
        onApply={handleNewReleasesFilterApply}
        initialValues={newReleasesAppliedFilters}
      />

      {/* Top Earning Filter Panel */}
      <FilterPanel
        open={topEarningFilterPanelOpen}
        sections={filterSections.length > 0 ? filterSections : undefined}
        // Platform is already selectable via the Meta Quest/Steam tabs above -
        // don't duplicate it inside the filter panel.
        hidePlatformSection
        onClose={() => setTopEarningFilterPanelOpen(false)}
        onApply={handleTopEarningFilterApply}
        initialValues={topEarningAppliedFilters}
      />
      {/* Top Discount Filter Panel */}
      <FilterPanel
        open={topDiscountFilterPanelOpen}
        sections={filterSections.length > 0 ? filterSections : undefined}
        // Platform is already selectable via the Meta Quest/Steam tabs above -
        // don't duplicate it inside the filter panel.
        hidePlatformSection
        onClose={() => setTopDiscountFilterPanelOpen(false)}
        onApply={handleTopDiscountFilterApply}
        initialValues={topDiscountAppliedFilters}
      />
    </React.Fragment>
  )
}

export default WeeklyInsightsDashboard